module.exports = __webpack_public_path__ + "static/img/ngzg_new1.82530fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ngzg_new1.png
// module id = Lb9N
// module chunks = 3